import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { RoutingStateService } from '@brightside/brightside-ui-services';
import {
  CacheStorageService,
  Campaign,
  CreditSetupStatus,
  FirebaseService,
  MobileStateService,
} from '@brightside-web/desktop/data-access/shared';
import { CampaignEventStatus, DisplayCampaignConfig } from '@brightside-web/shared/display';
import { Intercom } from '@supy-io/ngx-intercom';
import { BsCacheService, BsChatService, BsHubService } from '@brightside-web/desktop/data-access/core-services';
import { Subscription } from 'rxjs';
import { DisplayCampaignEvent } from '@brightside-web/shared/display';
import { CreditSetupService } from '@brightside-web/desktop/data-access/credit';

@Component({
    selector: 'brightside-web-creation',
    templateUrl: './creation.component.html',
    styleUrls: ['./creation.component.scss'],
    standalone: false
})
export class CreationComponent implements OnInit, OnDestroy {

  supportNumber: string; // = Cache.getItem('supportNumber');

  showForwardConfirm = false;
  showFatalError = false;

  campaign: DisplayCampaignConfig = {
    key: 'setupcredit',
    titleKey: 'CREDIT_INTRO_TITLE',
    image: 'credit_hero',
    textBodyKey: 'CREDIT_INTRO_DESC',
    textBodyAlign: 'left',
    textBodyNoWrap: true,
    ctaKey: 'GET_STARTED',
    secondaryCtaPath: '',
    secondaryCta: '',
    ctaPath: 'credit-setup/consents',
    isCreditIntro: true,
    backButtonLabel: 'BACK_WEB',
  };
  ready: boolean;
  pageOnBackCtaPath = ['home'];
  pageOnForwardCtaPath = ['credit-setup', 'consents'];
  private sub = new Subscription();
  private currentStatus: CreditSetupStatus;
  private onboarding: boolean;

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private routingState: RoutingStateService,
    private mobileStateService: MobileStateService,
    private analytics: FirebaseService,
    private intercom: Intercom,
    private cacheStorageSvc: CacheStorageService,
    private bsCacheService: BsCacheService,
    private bsHubService: BsHubService,
    private _bsChatService: BsChatService,
    private _creditSetupService: CreditSetupService
  ) {
    this.cacheStorageSvc.getItem('supportNumber').then((number) => {
      this.supportNumber = number;
    });

    this.bsCacheService.getItem('ONBOARDING_FLOW_ACTIVE').then((onboarding) => {
      if (onboarding) {
        this.campaign.backButtonLabel = 'BUTTON_SKIP';
        this.onboarding = true;
      }
      this.ready = true;
    });
  }

  ngOnInit() {
    this.checkForConfigViaData();
    this.checkStatusAndHandleAsNeeded();

    this.setUpHub();
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }

  handleCampaignEvent(event: DisplayCampaignEvent) {
    if (event.type === CampaignEventStatus.FAILED) {
      this.handleRouteBackward(true);
    } else if (event.type === CampaignEventStatus.SUCCESS) {
      this.handleRouteForward();
    }
  }



  handleFatalErrorCtaClick() {
    if (this.onboarding) {
      this._creditSetupService.creditFailed.set(true);
      return this.router.createUrlTree(['onboarding']);
    } else {
      this._bsChatService.showChat();
      this.router.navigate(['home']);
    }
  }

  private checkForConfigViaData() {
    if (this.activatedRoute?.snapshot?.queryParams?.status) {
      this.currentStatus = this.activatedRoute.snapshot.queryParams.status as CreditSetupStatus;
    } else {
      console.log('No configs have been passed in the DATA of the route.');
    }
  }

  private checkStatusAndHandleAsNeeded() {
    if (this.activatedRoute?.snapshot?.queryParams?.statusCode === '429') {
      this._bsChatService.showChat();
      this.handleRouteForward(true, ['home']);
    } else if (this.currentStatus === CreditSetupStatus.VERIFICATION_FAILED) {
      this.showFatalError = true;
    }
  }

  private setUpHub() {
    this.bsHubService.listen('ErrorChannel', () => {});
  }

  private handleRoute(popHistory: boolean, routeHere: string[]) {
    if (popHistory) {
      this.routingState.popAndNavigateTo(routeHere);
    } else {
      this.router.navigate(routeHere);
    }
  }

  private handleRouteBackward(popHistory?: boolean, overrideRoute?: string[]) {
    if (this.onboarding) {
      this._creditSetupService.creditFailed.set(true);
      return this.router.createUrlTree(['onboarding']);
    } else {
      const routeHere = overrideRoute || this.pageOnBackCtaPath;
      this.handleRoute(popHistory || false, routeHere);
    }
  }

  private handleRouteForward(popHistory?: boolean, overrideRoute?: string[]) {
    const routeHere = overrideRoute || this.pageOnForwardCtaPath;
    this.handleRoute(popHistory || false, routeHere);
  }

  private handleBackButton() {

  }
}
